export default __webpack_public_path__ + "static/media/play_city.ad6fd709.png";